<template>
  <div class="maintenance-container">
    <!-- 标题或顶部操作区（可选） -->
    <a-flex gap="middle" vertical style="margin-top: 50px;"> 
      <p>当前操作门店：{{ shopNo }} -- {{ shopName }}</p>
    </a-flex>

    <!-- 模块 1：会员解绑 -->
    <div class="maintain-card" style="margin-top: 30px;">
      <div class="card-header">会员管理</div>
      <div class="card-body row-align-center">
        <span class="label">会员绑定时间：</span>
        
        <a-date-picker 
          v-model:value="value1" 
          placeholder="请选择时间"
          style="width: 200px; margin-right: 12px;" 
          @change="onChange1"
          type="date"
        />
        
        <span class="tip-text">解绑小于并包含这个时间的会员</span>
        
        <a-button type="primary" @click="unbind" class="action-btn">
          一键解绑门店会员
        </a-button>
      </div>
      <div class="card-footer">
        <a-typography-text type="secondary" style="font-size: 12px;">
          注意：显示成功只是本服务器会员解绑已成功，异步调用八达服务器接口。
        </a-typography-text>
      </div>
    </div>

    <!-- 模块 2：支付订单删除 -->
    <div class="maintain-card">
      <div class="card-header">订单管理 - 支付订单</div>
      <div class="card-body row-align-center">
        <span class="label">订单生成时间：</span>
        
        <a-date-picker 
          v-model:value="value2" 
          placeholder="请选择时间"
          style="width: 200px; margin-right: 12px;" 
          @change="onChange2"
          type="date"
        />
        
        <span class="tip-text">删除小于并包含这个时间的订单</span>
        
        <a-button type="primary" danger @click="deleteOrder" class="action-btn">
          一键删除支付订单
        </a-button>
      </div>
      <div class="card-footer">
          <a-typography-text type="secondary" style="font-size: 12px;">
            注意：帮砍订单表、拼团订单表是从20260703 10:00:00 开始的订单才可删
          </a-typography-text>
        </div>

    </div>

    <!-- 模块 3：兑换订单删除 -->
    <div class="maintain-card">
      <div class="card-header">订单管理 - 兑换订单</div>
      <div class="card-body row-align-center">
        <span class="label">订单生成时间：</span>
        
        <a-date-picker 
          v-model:value="value3" 
          placeholder="请选择时间"
          style="width: 200px; margin-right: 12px;" 
          @change="onChange3"
          type="date"
        />
        
        <span class="tip-text">删除小于并包含这个时间的兑换订单</span>
        
        <a-button type="primary" danger @click="deleteExchangeOrder" class="action-btn">
          一键删除兑换订单
        </a-button>
        
      </div>
    </div>

    <a-button type="default" @click="$router.back()" style="margin-top: 20px;">
      返回
    </a-button>
  </div>
</template>

<script>
import { message } from "ant-design-vue";
import { payOrderDel, payOrderDelExchange, unbindStoreMember } from "@/api/homeApi.js";

export default {
  data() {
    return {
      value1: null, // 建议初始化为 null 而不是空字符串，符合 DatePicker 规范
      value2: null,
      value3: null,
      shopName:"",
      shopId:"",
      shopNo:"",
    };
  },
  mounted(){
    this.shopName = this.$route.query.shopName;
    this.shopId = this.$route.query.shopId;
    this.shopNo = this.$route.query.shopNo;
  },
  methods: {
    onChange1(date, dateString) {
      this.value1 = dateString;
      console.log(this.value1)
    },
    onChange2(date, dateString) {
      this.value2 = dateString;
      console.log(this.value2)
    },
    onChange3(date, dateString) {
      this.value3 = dateString;
      console.log(this.value3)
    },
    unbind() {
      if (!this.value1) {
        message.warning("请先选择会员绑定时间");
        return;
      }
      
      if(!this.shopId){
        message.error("门店不能为空");
        return;
      }
      unbindStoreMember(this.value1, this.shopId).then((res) => {
        if (res.success && res.data !== undefined) { // 修正判断逻辑
          message.success(`解绑成功 ${res.data} 条`);
        } else {
          message.error(res.info || "解绑失败");
        }
      }).catch(err => {
        console.log(err);
        message.error("网络请求异常");
      });
    },
    deleteOrder() {
      if (!this.value2) {
        message.warning("请先选择订单生成时间");
        return;
      }
      if(!this.shopId){
        message.error("请选择门店");
        return;
      }
      payOrderDel(this.value2, this.shopId).then((res) => {
        if (res.success) {
          message.success(`订单删除成功 ${res.data} 条`);
        } else {
          message.error(res.info || "删除失败");
        }
      }).catch(err => {
        message.error("网络请求异常");
      });
    },
    deleteExchangeOrder() {
      if (!this.value3) {
        message.warning("请先选择订单生成时间");
        return;
      }
      if(!this.shopId){
        message.error("请选择门店");
        return;
      }
      payOrderDelExchange(this.value3, this.shopId).then((res) => {
        if (res.success) {
          message.success(`兑换订单删除成功 ${res.data} 条`);
        } else {
          message.error(res.info || "删除失败");
        }
      }).catch(err => {
        message.error("网络请求异常");
      });
    },
  },
};
</script>

<style scoped>
.maintenance-container {
  padding: 20px;
  background-color: #f5f5f5; /* 背景色区分 */
  min-height: 100%;
  
}

.maintain-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 1200px; /* 限制最大宽度，避免在大屏上太散 */
  margin-left: auto;
  margin-right: auto;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
  border-left: 4px solid #1890ff; /* Ant Design 主色 */
  padding-left: 10px;
  color: #333;
}

/* 核心布局类：让一行内的所有元素垂直居中 */
.row-align-center {
  display: flex;
  flex-direction: row;
  align-items: center; /* 关键：垂直居中对齐 */
  flex-wrap: wrap;     /* 允许在小屏幕换行 */
  gap: 12px;           /* 元素间距 */
}

.label {
  font-weight: 500;
  color: #333;
  white-space: nowrap; /* 防止标签换行 */
}

.tip-text {
  color: #888;
  font-size: 13px;
  margin-left: 8px;
  margin-right: 8px;
}

.action-btn {
  margin-left: auto; /* 将按钮推到最右侧，如果空间足够 */
  /* 如果希望按钮紧跟文字，去掉 margin-left: auto 即可 */
}

.card-footer {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

/* 响应式调整：小屏幕下堆叠显示 */
@media (max-width: 768px) {
  .row-align-center {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .action-btn {
    margin-left: 0;
    width: 100%;
  }
  
  .tip-text {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/right/maintain/maintain.vue